import React, { useContext } from 'react'
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { makeStyles, Theme } from '@material-ui/core/styles'
import SequenceModifications from './SequenceModifications'
import InternalBases from './InternalBases'
import OptionalBases from './OptionalBases'
import InlineModifications from './InlineModifications'
import messages from '../../messages'
import Modifications from './Modifications'
import AminoAcid from './AminoAcid'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  TubeProduct,
  TubeProperties,
  Modification,
  probeTypes,
} from '../../utils/enum'
import { configContext } from '../../utils/StandardReducer'
import ValidationErrors from '../../validations/ValidationErrors'
import { checkValidKey } from '@src/routes/Configurators/utils/util'
import { useRouter } from 'next/router'
import getConfig from 'next/config'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 5),
    },
    panelSummary: {
      fontWeight: 'bold',
      padding: theme.spacing(0),
      fontSize: theme.typography.pxToRem(16),
    },
    expanded: {
      color: theme.palette.primary.main,
    },
    paddingBottom: {
      paddingBottom: theme.spacing(5),
    },
    tradeMarkLinkCSS: {
      float: 'right',
      color: theme.palette.primary.main,
    },
    modificationPadding: {
      paddingBottom: theme.spacing(6),
    },
    modificationHeader: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 'bold',
      paddingBottom: theme.spacing(3),
    },
    modificationInfo: {
      fontSize: theme.typography.pxToRem(14),
    },
    linkCSS: {
      color: theme.palette.primary.main,
    },
    activePanelIcon: {
      color: theme.palette.primary.main,
    },
    panelDetails: {
      display: 'inherit',
    },
    mgBottom: {
      marginBottom: theme.spacing(8),
    },
    panelContainer: {
      boxShadow: 'none',
      '&:before': {
        opacity: 1,
      },
    },
    panelExpansion: {
      fontWeight: 'bold',
      padding: theme.spacing(0),
      fontSize: theme.typography.pxToRem(16),
      marginLeft: theme.spacing(-5),
    },
  }
})

const OptionalModifications = (props) => {
  const {
    publicRuntimeConfig: { featureFlags },
  } = getConfig()

  const classes = useStyles()
  const router = useRouter()
  const intl = useIntl()
  const [expanded, setExpanded] = React.useState<string | false>(false)
  const [expandedList, setExpandedList] = React.useState<string[]>([])
  const { modificationResponseData, productDetails } = props
  const { state, dispatch } = useContext(configContext)
  const { errorIcon, isTubePageLoad, isDeletePerform, currentOligoIndex } =
    state
  const [isPageLoad, setIsPageLoad] = React.useState<boolean>(true)
  const [cTerminalError, setCTerminalError] = React.useState<string[]>([])
  const [nTerminalError, setNTerminalError] = React.useState<string[]>([])

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      let pannels: any = []
      if (expandedList.length) {
        pannels = expandedList
        if (pannels.includes(panel) && !isExpanded) {
          if (pannels.length === 1) {
            pannels = []
          } else {
            pannels.splice(pannels.indexOf(panel), 1)
          }
        }
      }
      setExpandedList(pannels)
      setExpanded(isExpanded ? panel : false)
    }

  const isCTerminalError = () => cTerminalError.length === 0
  const isNTerminalError = () => nTerminalError.length === 0

  const renderComponent = (props) => {
    if (
      productDetails.productType === TubeProduct.Aqua &&
      props === modificationResponseData.modifications[0]
    ) {
      return (
        <AminoAcid
          modificationResponseData={modificationResponseData}
          productType={productDetails.productType}
          modificationType={
            modificationResponseData.modifications[0].modificationType
          }
        ></AminoAcid>
      )
    } else if (
      productDetails.productType === TubeProduct.Aqua &&
      props === modificationResponseData.modifications[1]
    ) {
      return (
        <>
          <div className={isNTerminalError() ? '' : classes.mgBottom}>
            <ValidationErrors errors={nTerminalError} />
          </div>
          <Modifications
            modificationResponseData={modificationResponseData}
            productDetails={productDetails}
            modificationType={
              modificationResponseData.modifications[1].modificationType
            }
          ></Modifications>
        </>
      )
    } else if (
      productDetails.productType === TubeProduct.Aqua &&
      props === modificationResponseData.modifications[2]
    ) {
      return (
        <AminoAcid
          modificationResponseData={modificationResponseData}
          productType={productDetails.productType}
          modificationType={
            modificationResponseData.modifications[2].modificationType
          }
        ></AminoAcid>
      )
    } else if (
      productDetails.productType === TubeProduct.Aqua &&
      props === modificationResponseData.modifications[3]
    ) {
      return (
        <>
          <div className={isCTerminalError() ? '' : classes.mgBottom}>
            <ValidationErrors errors={cTerminalError} />
          </div>
          <Modifications
            modificationResponseData={modificationResponseData}
            productDetails={productDetails}
            modificationType={
              modificationResponseData.modifications[3].modificationType
            }
          ></Modifications>
        </>
      )
    }
    if (
      ((productDetails.productType === TubeProduct.Rna ||
        productDetails.productType === TubeProduct.Wellred ||
        productDetails.productType === TubeProduct.LongOligo) &&
        props.modificationType === Modification.FiveMod) ||
      (productDetails.productType === TubeProduct.Rna &&
        props.modificationType === Modification.ThreeMod) ||
      ((productDetails.productType === TubeProduct.Probe ||
        productDetails.productType === TubeProduct.Beacon) &&
        props.modificationType === Modification.QuencherMod) ||
      (productDetails.productType === TubeProduct.Cpeptide &&
        props.modificationType === Modification.CTerminalMod) ||
      (productDetails.productType === TubeProduct.Cpeptide &&
        props.modificationType === Modification.NTerminalMod)
    ) {
      return (
        <Modifications
          modificationResponseData={modificationResponseData}
          productDetails={productDetails}
          modificationType={props.modificationType}
        />
      )
    } else if (
      (productDetails.productType === TubeProduct.LongOligo &&
        props === modificationResponseData.modifications[1] &&
        props.modificationType === Modification.InternalMod) ||
      (productDetails.productType === TubeProduct.Cpeptide &&
        props.modificationType === Modification.InternalMod)
    ) {
      return (
        <InternalBases
          modificationResponseData={modificationResponseData}
          productType={productDetails.productType}
          countryCode={productDetails.countryCode}
        />
      )
    } else if (
      (productDetails.productType === TubeProduct.Rna &&
        props.modificationType === Modification.OptionalBase) ||
      ((productDetails.productType === TubeProduct.Standard ||
        productDetails.productType === TubeProduct.iscaledna) &&
        props.modificationType === Modification.OptionalBase) ||
      ((productDetails.productType === TubeProduct.Probe ||
        productDetails.productType === TubeProduct.Beacon) &&
        props.modificationType === Modification.OptionalBase)
    ) {
      return (
        <OptionalBases
          modificationResponseData={modificationResponseData}
          productType={productDetails.productType}
        />
      )
    } else if (
      (productDetails.productType === TubeProduct.Standard ||
        productDetails.productType === TubeProduct.iscaledna) &&
      props.modificationType === Modification.FiveMod
    ) {
      return (
        <SequenceModifications
          modificationResponseData={modificationResponseData}
          productType={productDetails.productType}
          productDetails={productDetails}
        />
      )
    } else if (
      (productDetails.productType === TubeProduct.Standard ||
        productDetails.productType === TubeProduct.iscaledna) &&
      props.modificationType === Modification.InternalMod
    ) {
      return (
        <InlineModifications
          modificationResponseData={modificationResponseData}
          productType={productDetails.productType}
          productDetails={productDetails}
        />
      )
    } else if (
      productDetails.productType === TubeProduct.LongOligo &&
      props === modificationResponseData.modifications[2]
    ) {
      return (
        <Modifications
          modificationResponseData={modificationResponseData}
          productDetails={productDetails}
          modificationType={
            modificationResponseData.modifications[2].modificationType
          }
        />
      )
    } else {
      return null
    }
  }

  const resetValidation = () => {
    setNTerminalError([])
    setCTerminalError([])
    dispatch({
      type: 'IS_DELETE_PERFORM',
      data: false,
    })
    dispatch({
      type: 'RESET_SPECIFICATION_ERROR_MSG',
      data: true,
    })
  }
  React.useEffect(() => {
    resetValidation()
    // TODO: need a test before we refactor these dependencies
  }, [isDeletePerform, currentOligoIndex])
  const checkModificationValidation = (response) => {
    const pannel: any = []
    setCTerminalError([])
    setNTerminalError([])
    const cTerminalErrorMsg: string[] = []
    const NTerminalErrorMsg: string[] = []
    if (response) {
      response.forEach((obj) => {
        if (
          obj.key === Modification.CTerminal &&
          obj.value !== TubeProperties.RequiredField &&
          obj.value !== TubeProperties.RequiredFieldError
        ) {
          cTerminalErrorMsg.push(obj.value)
          pannel.push(TubeProperties.Panel4)
          setExpanded(TubeProperties.Panel4)
        }
        if (
          obj.key === Modification.NTerminal &&
          obj.value !== TubeProperties.RequiredField &&
          obj.value !== TubeProperties.RequiredFieldError
        ) {
          pannel.push(TubeProperties.Panel2)
          setExpanded(TubeProperties.Panel2)
          NTerminalErrorMsg.push(obj.value)
        }
        if (
          obj.key === Modification.Fivemod ||
          obj.key === Modification.FiveMod
        ) {
          pannel.push(TubeProperties.Panel1)
          setExpanded(TubeProperties.Panel1)
        }
        if (obj.key === Modification.FiveModThreeMod) {
          pannel.push(TubeProperties.Panel1)
          setExpanded(TubeProperties.Panel1)
        }
        if (
          obj.key === Modification.Threemod ||
          obj.key === Modification.ThreeMod
        ) {
          pannel.push(TubeProperties.Panel1)
          setExpanded(TubeProperties.Panel1)
        }
        if (obj.value === TubeProperties.LabeledAminoAcidRequired) {
          pannel.push(TubeProperties.Panel1)
          setExpanded(TubeProperties.Panel1)
        }
      })
    }
    setExpandedList(pannel)
    setCTerminalError(cTerminalErrorMsg)
    setNTerminalError(NTerminalErrorMsg)
  }
  React.useEffect(() => {
    if (
      (productDetails.productType === TubeProduct.Probe ||
        productDetails.productType === TubeProduct.Beacon) &&
      (errorIcon || isPageLoad)
    ) {
      setIsPageLoad(false)
      setExpanded(TubeProperties.Panel1)
    }
    if (productDetails.productType === TubeProduct.Aqua && !errorIcon) {
      setExpanded(TubeProperties.Panel1)
    }
    // TODO: need a test before we refactor these dependencies
  }, [errorIcon])

  React.useEffect(() => {
    if (state.addOligo) {
      if (
        productDetails.productType === TubeProduct.Probe ||
        productDetails.productType === TubeProduct.Beacon ||
        productDetails.productType === TubeProduct.Aqua
      ) {
        setExpanded(TubeProperties.Panel1)
      } else {
        setExpanded(false)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.addOligo])

  React.useEffect(() => {
    if (
      (productDetails.productType === TubeProduct.Aqua ||
        productDetails.productType === TubeProduct.Standard) &&
      state.totalValidation.listErrors
    ) {
      checkModificationValidation(state.totalValidation.listErrors)
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.totalValidation])

  React.useEffect(() => {
    if (
      (productDetails.productType === TubeProduct.Aqua ||
        productDetails.productType === TubeProduct.Standard) &&
      state.errorResponseJson.listErrors
    ) {
      checkModificationValidation(state.errorResponseJson.listErrors)
    }
    // TODO: need a test before we refactor these dependencies
  }, [isTubePageLoad, state.errorResponseJson])

  const handleExpand = (panels: string) => {
    if (expandedList.length && panels && expandedList.includes(panels)) {
      return true
    }
    return expanded === panels
  }

  const getCategoryDisplayName = (
    modifications: any,
    probeType: string | undefined
  ) => {
    const categoryKey =
      probeType === probeTypes.DualLabel || !probeType
        ? probeTypes.Default
        : probeType
    const category = modifications.category.find(
      (data) => data.categoryName === categoryKey
    )

    return category ? category.categoryDisplayName : ''
  }

  const panelDisplay = () => {
    if (productDetails.productType !== TubeProduct.Wellred) {
      const expansioPanels: any[] = []
      const panels: any[] = ['panel1', 'panel2', 'panel3', 'panel4', 'panel5']
      let i = 0
      let j = 0

      if (
        productDetails.productType === TubeProduct.Standard ||
        productDetails.productType === TubeProduct.iscaledna
      ) {
        const modifications: any[] = []
        modificationResponseData.modifications.forEach((modification: any) => {
          if (Modification.ThreeMod === modification.modificationType) {
            modifications[0] = modification
          } else if (Modification.FiveMod === modification.modificationType) {
            modifications[1] = modification
          } else if (
            Modification.InternalMod === modification.modificationType
          ) {
            modifications[2] = modification
          } else if (
            Modification.OptionalBase === modification.modificationType
          ) {
            modifications[3] = modification
          }
        })
        modificationResponseData.modifications = modifications
      }

      modificationResponseData.modifications.forEach(
        (modification: any, index) => {
          if (
            (productDetails.productType === TubeProduct.Standard ||
              productDetails.productType === TubeProduct.iscaledna) &&
            modification.modificationType === Modification.ThreeMod
          ) {
            return
          }
          if (
            modificationResponseData.modifications[index].category.length !== 0
          ) {
            expansioPanels.push(
              <Accordion
                key={index}
                expanded={handleExpand(panels[i])}
                onChange={handleChange(panels[i])}
                classes={{ root: classes.panelContainer }}
              >
                <AccordionSummary
                  classes={{
                    root: classes.panelSummary,
                    expanded: classes.expanded,
                  }}
                >
                  {expanded === panels[i] ? (
                    <KeyboardArrowDownIcon
                      className={classes.activePanelIcon}
                    />
                  ) : expandedList.length !== 0 ? (
                    expandedList.includes(panels[i]) ? (
                      <KeyboardArrowDownIcon
                        className={classes.activePanelIcon}
                      />
                    ) : (
                      <KeyboardArrowRightIcon
                        className={classes.activePanelIcon}
                      />
                    )
                  ) : (
                    <KeyboardArrowRightIcon
                      className={classes.activePanelIcon}
                    />
                  )}

                  {productDetails.productType === TubeProduct.Standard ||
                  productDetails.productType === TubeProduct.iscaledna
                    ? intl.formatMessage(
                        checkValidKey(
                          messages[modification.modificationTypeDisplayName],
                          modification.modificationTypeDisplayName
                        )
                      )
                    : productDetails.productType === TubeProduct.Probe
                      ? modification.modificationType ===
                          Modification.QuencherMod &&
                        featureFlags.internalAndDualQuenchProbes
                        ? intl.formatMessage(
                            checkValidKey(
                              messages[
                                getCategoryDisplayName(
                                  modificationResponseData.modifications[j],
                                  router.query.probeType
                                )
                              ],
                              getCategoryDisplayName(
                                modificationResponseData.modifications[j],
                                router.query.probeType
                              )
                            )
                          )
                        : intl.formatMessage(
                            checkValidKey(
                              messages[
                                modificationResponseData.modifications[j]
                                  .modificationTypeDisplayName
                              ],
                              modificationResponseData.modifications[j]
                                .modificationTypeDisplayName
                            )
                          )
                      : intl.formatMessage(
                          checkValidKey(
                            messages[
                              modificationResponseData.modifications[j]
                                .modificationTypeDisplayName
                            ],
                            modificationResponseData.modifications[j]
                              .modificationTypeDisplayName
                          )
                        )}
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.panelDetails }}>
                  {productDetails.productType === TubeProduct.Standard ||
                  productDetails.productType === TubeProduct.iscaledna
                    ? renderComponent(modification)
                    : renderComponent(
                        modificationResponseData.modifications[j]
                      )}
                </AccordionDetails>
              </Accordion>
            )
          }
          i = i + 1
          j = j + 1
        }
      )
      return expansioPanels
    } else {
      return (
        <div className={classes.contentWrapper}>
          <AccordionSummary classes={{ root: classes.panelExpansion }}>
            {<FormattedMessage {...messages.CONF_OPTIONAL_MOD_rna} />}
          </AccordionSummary>

          {renderComponent(modificationResponseData.modifications[0])}
        </div>
      )
    }
  }

  return (
    <div className={classes.contentWrapper}>
      {productDetails.productType === TubeProduct.Standard && (
        <div className={classes.modificationPadding}>
          <div className={classes.modificationHeader}>
            <FormattedMessage {...messages.CONF_MODIFICATION} />
          </div>
          <div className={classes.modificationInfo}>
            <FormattedMessage
              {...messages.CONF_MODIFICATION_INFO}
              values={{
                TrademarkURL: (
                  <a
                    href={`${TubeProperties.TradeMarkURL}`}
                    className={classes.linkCSS}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FormattedMessage
                      {...messages.CONF_TRADEMARK_LICENSE_INFORMATION}
                    />
                  </a>
                ),
                ModificationsTechnicalResourceURL: (
                  <a
                    href={`${TubeProperties.ModificationsTechnicalResourceURL}`}
                    className={classes.linkCSS}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FormattedMessage
                      {...messages.CONF_MODIFICATION_TECHNICAL_RESOURCE}
                    />
                  </a>
                ),
              }}
            />
          </div>
        </div>
      )}
      {(productDetails.productType === TubeProduct.iscaledna ||
        productDetails.productType === TubeProduct.Probe ||
        productDetails.productType === TubeProduct.Beacon ||
        productDetails.productType === TubeProduct.LongOligo) && (
        <div className={classes.paddingBottom}>
          <a
            href={`${TubeProperties.TradeMarkURL}`}
            className={classes.tradeMarkLinkCSS}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage
              {...messages.CONF_TRADEMARK_LICENSE_INFORMATION}
            />
          </a>
        </div>
      )}

      {panelDisplay()}
    </div>
  )
}

export default OptionalModifications
